/* Flexera PDP redesign — ownership picker behaviour.
   Presentational only: Buy submits the normal product form, Rent navigates to
   the rental product (Supercycle flow), Finance navigates to the finance URL. */
(function () {
  if (window.__pdpOwnershipInit) return;
  window.__pdpOwnershipInit = true;

  function sectionElements(picker) {
    var sectionId = picker.dataset.sectionId;
    return {
      submit: document.getElementById('ProductSubmitButton-' + sectionId),
      buttons: document.querySelector('#product-form-' + sectionId + ' .product-form__buttons'),
      rentCta: picker.querySelector('.pdp-ownership__rent-cta'),
      financeCta: picker.querySelector('.pdp-ownership__finance-cta'),
    };
  }

  function applyPlan(picker, plan) {
    picker.querySelectorAll('.pdp-ownership__option').forEach(function (option) {
      option.classList.toggle('is-selected', option.dataset.plan === plan);
    });
    var els = sectionElements(picker);
    var showForm = plan === 'buy';
    if (els.buttons) els.buttons.toggleAttribute('hidden', !showForm);
    if (els.rentCta) els.rentCta.toggleAttribute('hidden', plan !== 'rent');
    if (els.financeCta) els.financeCta.toggleAttribute('hidden', plan !== 'finance');
    var terms = picker.querySelector('[data-pdp-terms]');
    if (terms) {
      terms.toggleAttribute('hidden', plan !== 'rent');
      if (plan === 'rent') syncRecurringRow(picker);
    }
    var financeTerms = picker.querySelector('[data-pdp-finance-terms]');
    if (financeTerms) {
      financeTerms.toggleAttribute('hidden', plan !== 'finance');
      if (plan === 'finance') syncFinance(picker);
    }
    applyColorLock(picker, plan);
  }

  /* Some plans sell only part of the colour range: rentals ship in the
     colours on the rental map, and Flex It skips colours switched off in the
     editor (e.g. one that is out of stock). Selecting such a plan moves the
     swatch to an allowed colour and locks the rest; leaving it unlocks them
     and restores what the shopper had chosen, so their pick is not silently
     lost. */
  function colorInputs(picker) {
    // Use the id string directly: the product form contains an input named
    // "id" (the variant field), and named controls shadow form.id — reading
    // it returns that element, not the string, so comparisons never match.
    var formId = 'product-form-' + picker.dataset.sectionId;
    var form = document.getElementById(formId);
    if (!form) return [];
    var scope = document.getElementById('pdp-buybox') || document;
    return Array.prototype.slice.call(
      scope.querySelectorAll('.product-form__input input[type="radio"]')
    ).filter(function (input) {
      return input.getAttribute('form') === formId || form.contains(input);
    });
  }

  function norm(v) {
    return String(v == null ? '' : v).trim().toLowerCase();
  }

  /* Colour -> rental variant id for this market, e.g.
     "Charcoal:55307242570057,Mocha:55307260723529".
     Keys are the colours that can actually be rented; everything else is
     locked out while Rent is selected. */
  function rentColorMap(picker) {
    var raw = picker.dataset.rentVariantMap;
    if (!raw) return null;
    var map = {};
    raw.split(',').forEach(function (pair) {
      var bits = pair.split(':');
      if (bits.length < 2) return;
      var color = norm(bits[0]);
      var id = parseInt(String(bits[1]).trim(), 10);
      if (color && id) map[color] = id;
    });
    return Object.keys(map).length ? map : null;
  }

  // Colours the rent flow accepts — map keys, or the legacy single colour.
  function rentableColors(picker) {
    var map = rentColorMap(picker);
    if (map) return Object.keys(map);
    var forced = picker.dataset.rentColor;
    return forced ? [norm(forced)] : [];
  }

  function selectedColorInput(picker) {
    return colorInputs(picker).filter(function (i) { return i.checked; })[0] || null;
  }

  // The rental variant depends on the colour the shopper has chosen.
  function rentalVariantId(picker) {
    var map = rentColorMap(picker);
    if (!map) return parseInt(picker.dataset.rentVariant, 10) || 0;
    var current = selectedColorInput(picker);
    if (current) {
      var hit = map[norm(current.value)];
      if (hit) return hit;
    }
    return map[rentableColors(picker)[0]] || 0;
  }

  function matchesForcedColor(input, allowed) {
    return allowed.indexOf(norm(input.value)) !== -1;
  }

  // Colours Flex It cannot sell right now, e.g. "Sage Green".
  function financeExcludedColors(picker) {
    var raw = picker.dataset.financeExcludedColors;
    if (!raw) return [];
    return raw.split(',').map(norm).filter(Boolean);
  }

  // Colours the plan accepts. Empty means the plan has no colour lock.
  function allowedColors(picker, plan, inputs) {
    if (plan === 'rent') return rentableColors(picker);
    if (plan === 'finance') {
      var excluded = financeExcludedColors(picker);
      if (!excluded.length) return [];
      return inputs
        .map(function (i) { return norm(i.value); })
        .filter(function (color) { return excluded.indexOf(color) === -1; });
    }
    return [];
  }

  // One lock shared by every plan, with one remembered colour, so moving
  // Rent -> Flex It -> Buy lands back on the shopper's original pick instead
  // of two locks fighting over the checked swatch.
  function applyColorLock(picker, plan) {
    var inputs = colorInputs(picker);
    if (!inputs.length) return;
    var allowed = allowedColors(picker, plan, inputs);
    var usable = inputs.filter(function (i) { return matchesForcedColor(i, allowed); });

    // Only lock if at least one allowed colour exists on this product.
    if (usable.length) {
      if (!picker.dataset.colorPrev) {
        var current = inputs.filter(function (i) { return i.checked; })[0];
        if (current) picker.dataset.colorPrev = current.value;
      }
      // Keep the shopper's colour when it is allowed; otherwise move them to
      // the first one that is, rather than silently switching every time.
      var alreadyOk = usable.some(function (i) { return i.checked; });
      if (!alreadyOk) {
        usable[0].checked = true;
        usable[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
      inputs.forEach(function (input) {
        var keep = matchesForcedColor(input, allowed);
        input.disabled = !keep;
        var label = input.labels && input.labels[0];
        if (label) label.classList.toggle('is-color-locked', !keep);
      });
      return;
    }

    inputs.forEach(function (input) {
      input.disabled = false;
      var label = input.labels && input.labels[0];
      if (label) label.classList.remove('is-color-locked');
    });
    var prev = picker.dataset.colorPrev;
    if (prev) {
      var restore = inputs.filter(function (i) { return i.value === prev; })[0];
      if (restore && !restore.checked) {
        restore.checked = true;
        restore.dispatchEvent(new Event('change', { bubbles: true }));
      }
      picker.dataset.colorPrev = '';
    }
  }

  function selectedTerm(picker) {
    var terms = picker.querySelector('[data-pdp-terms]');
    return terms ? terms.querySelector('input:checked') : null;
  }

  function syncRecurringRow(picker) {
    var term = selectedTerm(picker);
    var row = picker.querySelector('[data-rent-recurring]');
    if (!term || !row || !term.dataset.price) return;
    row.textContent = term.dataset.price + '/wk';
  }

  function syncTermPrice(picker) {
    var term = selectedTerm(picker);
    if (!term || !term.dataset.price) return;
    var priceEl = picker.querySelector('.pdp-ownership__option[data-plan="rent"] .pdp-ownership__price');
    if (priceEl) {
      priceEl.innerHTML = '';
      priceEl.appendChild(document.createTextNode(term.dataset.price));
      var period = document.createElement('span');
      period.className = 'pdp-ownership__period';
      period.textContent = '/wk';
      priceEl.appendChild(period);
    }
  }

  /* ---------------------------------------------------------------
     Finance it — Flexera's own interest-free instalment plan.
     Not a third-party lender: the customer pays the first instalment at
     checkout and the rest are charged monthly to the same card. The total
     equals the outright price; there is no fee or interest.

     Every amount rendered here is a pre-formatted label from the pricing
     API. Instalments are NOT total / n — the remainder lands on the first
     payment — so computing them in the theme would disagree with the
     checkout by a cent.
     --------------------------------------------------------------- */

  // Variant SKU -> checkout slug. Derived from the SKU, never from product
  // tags or ids, so a mis-tagged product cannot route to the wrong basket.
  function bundleSlugFor(variantSku) {
    if (!variantSku) return null;
    var sku = String(variantSku).toUpperCase();
    if (/^FLD-.*-FP-/.test(sku)) return 'bundle-folding';
    if (/^STD-.*-FP-/.test(sku)) return 'bundle-studio';
    return null; // rentals (-REN) have no payment plan; anything else 404s
  }

  // Resolve the live variant at call time. Dawn morphs the section on change,
  // so anything Liquid rendered earlier may describe the previous colour.
  function liveVariant(picker) {
    var mapEl = picker.querySelector('script.flexera-variant-map');
    var form = document.querySelector('#product-form-' + picker.dataset.sectionId);
    var input = form && form.querySelector('input[name="id"]');
    if (!mapEl || !input) return null;
    try {
      return JSON.parse(mapEl.textContent)[input.value] || null;
    } catch (error) {
      return null;
    }
  }

  function selectedFinance(picker) {
    var terms = picker.querySelector('[data-pdp-finance-terms]');
    return terms ? terms.querySelector('input:checked') : null;
  }

  // Only gbp and eur are accepted; the backend rejects anything else.
  function currencyFor(picker) {
    var code = (picker.dataset.currency || '').toLowerCase();
    return code === 'gbp' || code === 'eur' ? code : null;
  }

  var priceCache = {};

  function fetchPricing(picker, sku) {
    var currency = currencyFor(picker);
    if (!currency) return Promise.reject(new Error('unsupported currency'));
    var key = sku + ':' + currency;
    if (priceCache[key]) return priceCache[key];
    var url = picker.dataset.apiBase + '/checkout/pricing/' + sku + '?currency=' + currency;
    if (window.fxCurrencyLog) window.fxCurrencyLog('Flex It pricing request', { sku: sku, currency: currency });
    priceCache[key] = fetch(url)
      .then(function (response) {
        // 503 PRICE_NOT_PROVISIONED means the Stripe price is missing. Show
        // nothing rather than a broken price, and leave the option unusable.
        if (!response.ok) throw new Error('pricing ' + response.status);
        return response.json();
      })
      .catch(function (error) {
        delete priceCache[key];
        throw error;
      });
    return priceCache[key];
  }

  function financeUnavailable(picker, unavailable) {
    var error = picker.querySelector('[data-finance-error]');
    var cta = picker.querySelector('.pdp-ownership__finance-cta');
    if (error) error.toggleAttribute('hidden', !unavailable);
    if (cta) cta.classList.toggle('is-disabled', unavailable);
    var option = picker.querySelector('.pdp-ownership__option[data-plan="finance"]');
    if (option) option.classList.toggle('is-unavailable', unavailable);
  }

  function renderFinance(picker, plans) {
    // Each option leads with its monthly amount — the figure shoppers actually
    // compare — so the tiles differ at a glance instead of repeating the same
    // sentence three times. Still a rendered API label, never recomputed.
    Object.keys(plans).forEach(function (suffix) {
      var instalment = plans[suffix] && plans[suffix].instalment;
      var perMonth = picker.querySelector('[data-finance-permonth="' + suffix + '"]');
      if (perMonth) perMonth.textContent = instalment ? instalment.perInstalment.label : '';
      var legacy = picker.querySelector('[data-finance-label="' + suffix + '"]');
      if (legacy) legacy.textContent = instalment ? instalment.label : '';
    });

    var checked = selectedFinance(picker);
    var active = checked && plans[checked.value];
    var instalment = active && active.instalment;
    if (!instalment) return;

    var set = function (selector, text) {
      var el = picker.querySelector(selector);
      if (el) el.textContent = text;
    };
    // Amount due today is always stated separately from the plan total: the
    // first instalment is charged immediately, so showing only the total
    // would misrepresent what the customer pays now.
    set('[data-finance-due-today]', instalment.dueToday.label);
    set('[data-finance-permonth-row]', instalment.perInstalment.label);
    // Spell out how many payments remain — the first is taken today, so the
    // count below the monthly figure is one less than the plan's count.
    var remaining = instalment.count - 1;
    set('[data-finance-remaining]', remaining + (remaining === 1 ? ' payment' : ' payments'));
    // headline and instalment.total are the same amount, but the backend
    // formats them differently (€2,399.00 vs €2399.00). Prefer headline so the
    // plan total matches the thousands separator used everywhere else, and
    // fall back to total if headline is ever absent. Still a rendered label —
    // never reformatted here.
    var planTotal = (active.headline && active.headline.label) || instalment.total.label;
    set('[data-finance-total]', planTotal);
    set('[data-finance-summary]', instalment.summary);

    var headline = picker.querySelector('[data-finance-headline]');
    if (headline) headline.textContent = instalment.label;
    if (window.fxCurrencyLog) {
      window.fxCurrencyLog('Flex It shown', {
        plan: checked && checked.value,
        headline: instalment.label,
        dueToday: instalment.dueToday.label,
        total: planTotal
      });
    }
  }

  // Plans come from the markup, so adding one is a theme-editor change.
  function financeOptions(picker) {
    return Array.prototype.slice.call(
      picker.querySelectorAll('[data-finance-option]')
    );
  }

  function syncFinance(picker) {
    if (!picker.dataset.apiBase) return;
    var variant = liveVariant(picker);
    var base = variant && bundleSlugFor(variant.sku);
    if (!base) {
      financeUnavailable(picker, true);
      return;
    }
    var options = financeOptions(picker);
    if (!options.length) return;

    // Each plan is fetched independently and never rejects: a plan the backend
    // has not provisioned (404 / 503) simply stays hidden, instead of taking
    // the whole picker down with it as Promise.all would.
    Promise.all(options.map(function (option) {
      var suffix = option.dataset.financeOption;
      return fetchPricing(picker, base + '-' + suffix)
        .then(function (data) { return [suffix, data]; })
        .catch(function () { return [suffix, null]; });
    }))
      .then(function (entries) {
        var plans = {};
        entries.forEach(function (entry) {
          if (entry[1] && entry[1].instalment) plans[entry[0]] = entry[1];
        });
        revealFinanceOptions(picker, plans);
        var available = Object.keys(plans).length;
        financeUnavailable(picker, available === 0);
        if (available) renderFinance(picker, plans);
      });
  }

  /* Show only the plans the API actually returned, and make sure the checked
     one is among them — otherwise the CTA would carry a SKU the checkout
     rejects. */
  function revealFinanceOptions(picker, plans) {
    var visible = [];
    financeOptions(picker).forEach(function (option) {
      var ok = Object.prototype.hasOwnProperty.call(plans, option.dataset.financeOption);
      option.toggleAttribute('hidden', !ok);
      if (ok) visible.push(option);
    });
    if (!visible.length) return;
    var checked = selectedFinance(picker);
    var checkedVisible = checked && visible.some(function (o) { return o.contains(checked); });
    if (!checkedVisible) {
      var first = visible[0].querySelector('input');
      if (first) first.checked = true;
    }
    visible.forEach(function (option) {
      var input = option.querySelector('input');
      option.classList.toggle('is-selected', !!(input && input.checked));
    });
  }

  function financeCheckoutUrl(picker) {
    var variant = liveVariant(picker);
    var base = variant && bundleSlugFor(variant.sku);
    var choice = selectedFinance(picker);
    var currency = currencyFor(picker);
    if (!base || !choice || !currency) return null;
    // The swatch lock hides excluded colours; this stops a stale page sending one.
    if (financeExcludedColors(picker).indexOf(norm(variant.color)) !== -1) return null;
    var params = new URLSearchParams({
      currency: currency,
      color: variant.color || '',
      variant_sku: variant.sku || '',
    });

    /* Marketing attribution rides across the domain hop as a pointer, never a
       payload. The .joinflexera.com cookie written by flexera-attribution.js
       is the primary carrier and is already readable on the checkout host;
       att= is the belt for a blocked cookie. att_d= carries a compact
       last-touch only while the durable server copy is NOT known to exist:
       no id at all, or the collect beacon never got a 2xx (ad blocker,
       corporate proxy, local theme dev pointed at a different API). Never
       carries fbp/fbc. Synchronous — the CTA never awaits a network call.
       Wrapped because a failure here must never stop a customer reaching
       checkout. */
    try {
      var attribution = window.FlexeraAttribution;
      if (attribution) {
        var sid = attribution.id();
        if (sid) params.set('att', sid);
        if (!sid || !attribution.beaconConfirmed()) {
          var degraded = attribution.degraded();
          if (degraded) params.set('att_d', degraded);
        }
      }
    } catch (error) {}

    return picker.dataset.checkoutBase + '/' + base + '-' + choice.value + '?' + params.toString();
  }

  // Without an href the CTA is a role=button, so Enter/Space must activate it.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var target = event.target.closest && event.target.closest('.pdp-ownership__finance-cta');
    if (!target) return;
    event.preventDefault();
    target.click();
  });

  // Finance CTA routes to the Flexera checkout with the live variant's SKU.
  document.addEventListener('click', function (event) {
    var cta = event.target.closest('.pdp-ownership__finance-cta');
    if (!cta) return;
    var picker = cta.closest('[data-pdp-ownership]');
    if (!picker || !picker.dataset.checkoutBase) return; // legacy finance_url link
    event.preventDefault();
    var url = financeCheckoutUrl(picker);
    if (url) window.location.href = url;
    else financeUnavailable(picker, true);
  });

  /* Homepage cards link with ?plan=buy|rent so one click lands on the PDP
     with that ownership option already chosen. Only honoured once per page
     load — after that the shopper's own clicks win. */
  var planFromUrl = (function () {
    try {
      var value = new URLSearchParams(window.location.search).get('plan');
      return value === 'rent' || value === 'buy' || value === 'finance' ? value : null;
    } catch (error) {
      return null;
    }
  })();
  var planFromUrlApplied = false;

  function applyPlanFromUrl(picker) {
    if (!planFromUrl || planFromUrlApplied) return false;
    var radio = picker.querySelector('input[value="' + planFromUrl + '"]');
    // The option can be switched off per product (e.g. Studio has no rental).
    if (!radio || radio.closest('.pdp-ownership__option').hasAttribute('hidden')) return false;
    radio.checked = true;
    planFromUrlApplied = true;
    applyPlan(picker, planFromUrl);
    return true;
  }

  function syncAll() {
    document.querySelectorAll('[data-pdp-ownership]').forEach(function (picker) {
      if (applyPlanFromUrl(picker)) return;
      var checked = picker.querySelector('input:checked');
      applyPlan(picker, checked ? checked.value : 'buy');
    });
    syncColorLabels();
  }

  // Design's label row: "Colour" left, selected value right.
  function syncColorLabels() {
    document.querySelectorAll('#pdp-buybox .product-form__input').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      var checked = fieldset.querySelector('input:checked');
      if (!legend || !checked) return;
      if (legend.querySelector('[data-selected-swatch-value], [data-selected-value]')) {
        // Dawn's swatch picker already prints the selected name natively
        focusVariantMedia(checked.value);
        return;
      }
      var span = legend.querySelector('.pdp-color-value');
      if (!span) {
        span = document.createElement('span');
        span.className = 'pdp-color-value';
        legend.appendChild(span);
      }
      span.textContent = checked.value;
      document.querySelectorAll('.pdp-gallery-color').forEach(function (pill) {
        pill.textContent = checked.value;
      });
      focusVariantMedia(checked.value);
    });
  }

  /* Bring the selected colour's photo into focus. Variants have no
     featured-media links in admin (yet), so match by filename/alt —
     the colourway images carry the colour name. Once admin assigns
     variant images, Dawn's native swap takes over and this is a no-op
     that agrees with it. */
  var COLOR_ALIASES = {
    'charcoal': ['charcoal', 'black'],
    'ivory': ['ivory', 'cream', 'natural', 'bone'],
    'mocha': ['mocha', 'clay', 'brown'],
    'sage green': ['sage-green', 'sage_green', 'sagegreen', 'sage', 'green'],
  };

  function focusVariantMedia(colorValue) {
    if (!colorValue) return;
    var gallery = document.querySelector('.product-redesign media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    var key = colorValue.toLowerCase().trim();
    var tokens = COLOR_ALIASES[key] || [key.replace(/\s+/g, '_'), key.replace(/\s+/g, '-'), key.split(/\s+/)[0]];
    var items = gallery.querySelectorAll('.product__media-item');
    for (var t = 0; t < tokens.length; t++) {
      for (var i = 0; i < items.length; i++) {
        var img = items[i].querySelector('img');
        if (!img) continue;
        var haystack = (img.src + ' ' + (img.alt || '')).toLowerCase();
        if (haystack.indexOf(tokens[t]) !== -1) {
          gallery.setActiveMedia(items[i].dataset.mediaId, true);
          return;
        }
      }
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input.closest && input.closest('.product-form__input')) {
      syncColorLabels();
      // Dawn re-renders the swatches on variant change, which drops the
      // disabled flags — reapply the lock while a locking plan is selected.
      document.querySelectorAll('[data-pdp-ownership]').forEach(function (p) {
        var checked = p.querySelector('input[name^="pdp-plan-"]:checked');
        if (checked && checked.value !== 'buy') applyColorLock(p, checked.value);
      });
      // Colour switch can change the variant SKU, so re-resolve finance pricing.
      document.querySelectorAll('[data-pdp-ownership]').forEach(function (p) {
        var open = p.querySelector('[data-pdp-finance-terms]:not([hidden])');
        if (open) syncFinance(p);
      });
    }
    if (input.name && input.name.indexOf('pdp-term-') === 0) {
      var termPicker = input.closest('[data-pdp-ownership]');
      if (termPicker) {
        termPicker.querySelectorAll('.pdp-ownership__term').forEach(function (t) {
          t.classList.toggle('is-selected', t.contains(input));
        });
        syncRecurringRow(termPicker);
      }
      return;
    }
    if (input.name && input.name.indexOf('pdp-finance-') === 0) {
      var financePicker = input.closest('[data-pdp-ownership]');
      if (financePicker) {
        financePicker.querySelectorAll('[data-pdp-finance-terms] .pdp-ownership__term').forEach(function (t) {
          t.classList.toggle('is-selected', t.contains(input));
        });
        syncFinance(financePicker);
      }
      return;
    }
    if (!input.name || input.name.indexOf('pdp-plan-') !== 0) return;
    var picker = input.closest('[data-pdp-ownership]');
    if (picker) applyPlan(picker, input.value);
  });

  /* Cart-mode renting: replicate the Supercycle widget's captured flow —
     (1) register the rental intent via the app proxy, (2) add the rental
     variant with its selling plan + _cycle/_validations properties and the
     deposit variant in one cart call. Any failure falls back to the link. */
  function todayISO() {
    var d = new Date();
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + mm + '-' + dd;
  }

  function rentToCart(picker, cta) {
    var ds = picker.dataset;
    // Resolved per colour, so Charcoal and Mocha add their own rental variant.
    var rentalVariant = rentalVariantId(picker);
    var plan = parseInt(ds.rentPlan, 10);
    var deposit = parseInt(ds.rentDeposit, 10);
    var optionGid = ds.rentOptionGid;
    var minimumTerm = ds.rentTerm || '3.month';
    var term = selectedTerm(picker);
    if (term) {
      if (term.dataset.planId) plan = parseInt(term.dataset.planId, 10);
      if (term.dataset.optionGid) optionGid = term.dataset.optionGid;
      if (term.dataset.term) minimumTerm = term.dataset.term;
    }
    if (!rentalVariant || !plan || !deposit) return Promise.reject(new Error('rent config missing'));

    var cycle = {
      start: { type: 'fulfillment', delivery_method_type: 'shipping' },
      end: { type: 'receival', return_method_type: 'shipping' },
      item: { type: 'existing', filters: { availability: { from: todayISO() } } },
      attachments: { deposit: { variant_id: deposit } },
      method_type: 'subscription',
      minimum_term: minimumTerm,
    };
    var validations = { required_variant: [{ id: deposit, per_line: 1 }] };

    function makeIntent() {
      return optionGid
        ? fetch('/apps/supercycle/intents', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              variantId: String(rentalVariant),
              option: { globalId: optionGid, params: { deliveryMethodType: 'shipping', returnMethodType: 'shipping' } },
            }),
          })
        : Promise.resolve();
    }

    // already in the cart? same term -> just show it; different term ->
    // update the existing line in place (never stack a second contract)
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existing = (cart.items || []).find(function (it) { return it.variant_id === rentalVariant; });
        if (existing) {
          var existingPlan = existing.selling_plan_allocation
            && existing.selling_plan_allocation.selling_plan
            && existing.selling_plan_allocation.selling_plan.id;
          if (existingPlan === plan) return refreshDrawer();
          return makeIntent().then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: existing.key,
                quantity: 1,
                selling_plan: plan,
                properties: { _cycle: JSON.stringify(cycle), _validations: JSON.stringify(validations) },
                sections: ['cart-drawer', 'cart-icon-bubble'],
                sections_url: window.location.pathname,
              }),
            });
          }).then(function (response) {
            if (!response || !response.ok) throw new Error('cart change failed');
            return response.json();
          }).then(function (data) {
            var drawer = document.querySelector('cart-drawer');
            if (data.sections && drawer && typeof drawer.renderContents === 'function') {
              drawer.renderContents(data);
              drawer.classList.remove('is-empty');
            } else {
              return refreshDrawer();
            }
          });
        }
        var intent = makeIntent();
        return intent.then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: rentalVariant,
                  quantity: 1,
                  selling_plan: plan,
                  properties: { _cycle: JSON.stringify(cycle), _validations: JSON.stringify(validations) },
                },
                { id: deposit, quantity: 1 },
              ],
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          });
        }).then(function (response) {
          if (!response || !response.ok) throw new Error('cart add failed');
          return response.json();
        }).then(function (data) {
          var drawer = document.querySelector('cart-drawer');
          if (data.sections && drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);
            drawer.classList.remove('is-empty');
          } else {
            return refreshDrawer();
          }
        });
      });
  }

  // Re-render the cart drawer from the Section Rendering API and open it.
  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: sections });
          drawer.classList.remove('is-empty');
        } else {
          window.location.href = '/cart';
        }
      });
  }

  document.addEventListener('click', function (event) {
    var cta = event.target.closest('.pdp-ownership__rent-cta');
    if (!cta) return;
    var picker = cta.closest('[data-pdp-ownership]');
    if (!picker || picker.dataset.rentMode !== 'cart') return;
    event.preventDefault();
    if (cta.dataset.busy === 'true') return;
    cta.dataset.busy = 'true';
    var label = cta.textContent;
    var errorEl = picker.querySelector('.pdp-ownership__error');
    if (errorEl) errorEl.setAttribute('hidden', '');
    cta.textContent = 'Adding…';
    rentToCart(picker, cta)
      .then(function () {
        cta.textContent = label;
        cta.dataset.busy = '';
      })
      .catch(function (error) {
        console.error('Rental add failed:', error);
        cta.textContent = label;
        cta.dataset.busy = '';
        if (errorEl) errorEl.removeAttribute('hidden');
      });
  });


  /* pricing-section "Start renting" scrolls to the buy box (anchor href)
     and pre-selects the Rent option so the term choice is already open. */
  document.addEventListener('click', function (event) {
    var cta = event.target.closest('.pdp-ownership-pricing__card--rent .pdp-ownership-pricing__cta');
    if (!cta) return;
    var picker = document.querySelector('[data-pdp-ownership]');
    if (!picker) return;
    var rentRadio = picker.querySelector('input[value="rent"]');
    if (rentRadio) {
      rentRadio.checked = true;
      applyPlan(picker, 'rent');
    }
  });

  // Initial sync (covers browser form restoration on soft reload / bfcache).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
  window.addEventListener('pageshow', syncAll);

  // Re-sync after theme editor section reloads.
  document.addEventListener('shopify:section:load', syncAll);

  // Keep the Buy option's price in step with the selected variant. Dawn's
  // product-info fetches the re-rendered section and publishes it on
  // variantChange — copy the fresh price out of that document.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var html = event && event.data && event.data.html;
      if (!html || typeof html.querySelector !== 'function') return;
      var fresh = html.querySelector('.pdp-ownership__option[data-plan="buy"] .pdp-ownership__price');
      if (!fresh) return;
      document.querySelectorAll('[data-pdp-ownership] .pdp-ownership__option[data-plan="buy"] .pdp-ownership__price').forEach(function (el) {
        el.textContent = fresh.textContent.trim();
      });
    });
  }
})();
